<template>
    <component
        :is="tag"
        class="relation-list-item"
        :class="{'-popovered': isItemPopovered}"
        ref="listItem"
        >
        <div class="js-drag-handle" v-if="showDragHandle">
            <div class="relation-list-item__ico-drag">
                <BaseIcon name="drag"/>
            </div>
        </div>
        <BaseImage class="relation-list-item__img" :image="image" objectFit="cover"/>
        <span class="relation-list-item__label">{{ label }}</span>

        <BaseButton class="relation-list-item__btn -info" ref="popoverTrigger" icon="circle-information" @click.native="showPopover"/>

        <slot name="selectionHandler">
            <BaseButton class="relation-list-item__btn" icon="circle-plus-outline"/>
        </slot>
        
        <Popover class="relation-list-item__popover" v-visible="isItemPopovered && isTriggerInFrame" ref="popover" v-click-outside="hidePopover">
            <h3>Details</h3>
            <p><strong>Title: </strong>{{ popoverData.label }} </p>
            <p v-if="popoverData.description"><strong>Description: </strong>{{ popoverData.description }}</p>
            <p v-if="popoverData.id"><strong>ID: </strong>{{ popoverData.id }}</p>
            <p v-if="popoverData.handle"><strong>Handle: </strong>{{ popoverData.handle }}</p>
            <button class="popover__close buttonTouchArea" @click="hidePopover" title="Close popover">✕</button>
        </Popover>
    </component>
</template>

<script>
import { requestAnimation } from '@/helpers';
import Popover from '@/components/Popover';
import { PopoverDataModel } from '@/models/popover-data.model'

const scrollAreaClassName = 'js-relation-list-item-scroll-area'

export {
    scrollAreaClassName,
}

export default {
    components: {
        Popover
    },

    props: {
        tag: { type: String, default: 'li' },
        label: String,
        image: [String, Object],
        popoverData: { type: PopoverDataModel, required: true },
        showDragHandle: Boolean,
    },

    data() {
        return {
            isItemPopovered: false,
            isTriggerInFrame: true,
            scrollArea: null
        };
    },

    methods: {
        handleScroll: requestAnimation(function(e) {
            if (!this.isItemPopovered) return;
            this.positionPopover();
            this.observePopoverVisibility();
        }),
        addListeners() {
            window.addEventListener('scroll', this.handleScroll);
            window.addEventListener('resize', this.handleScroll);
            this.scrollArea.addEventListener('scroll', this.handleScroll)
        },
        removeListeners() {
            window.removeEventListener('scroll', this.handleScroll);
            window.removeEventListener('resize', this.handleScroll);
            this.scrollArea.removeEventListener('scroll', this.handleScroll)
        },
        positionPopover() {
            const popoverTrigger = this.$refs.popoverTrigger.$el;
            const item = this.$refs.listItem;
            const rect = popoverTrigger.getBoundingClientRect();
            const popoverEl = this.$refs.popover.$el;
            const offset = 10;
            item.style = "";
            Object.assign(popoverEl.style, {
                top: rect.top + rect.height + offset + 'px',
                left: rect.left + rect.width / 2 - popoverEl.offsetWidth / 2 + 'px',
                position: 'fixed',
            });
        },
        showPopover() {
            setTimeout(() => {
                this.positionPopover();
                this.addListeners()
                this.isItemPopovered = true;
                this.isTriggerInFrame = true;
            }, 0);
        },
        hidePopover() {
            this.isItemPopovered = false;
            this.removeListeners()
        },
        observePopoverVisibility() {
            const popoverTrigger = this.$refs.popoverTrigger.$el;
            const triggerRect = popoverTrigger.getBoundingClientRect();
            const frameRect = this.scrollArea.getBoundingClientRect();
            const offset = 0;
            const isTriggerOverFrame =
                triggerRect.bottom + offset < frameRect.top;
            const isTriggerBelowFrame =
                triggerRect.top + offset > frameRect.bottom;

            if (isTriggerOverFrame || isTriggerBelowFrame) {
                this.isTriggerInFrame = false;
            } else {
                this.isTriggerInFrame = true;
            }
        }
    },

    mounted() {
        this.scrollArea = this.$refs.popoverTrigger.$el.closest('.' + scrollAreaClassName)
    },

    beforeDestroy() {
        this.removeListeners();
    }
};
</script>

<style lang="scss">
@import './src/assets/styles/colors.scss';
@import './src/assets/styles/breakpoints.scss';

.relation-list-item {
    display: flex;
    align-items: center;
    padding: 10px;
    font-size: 15px;
    font-weight: 500;
    position: relative;

    &__ico-drag {
        padding: 25px 10px 25px 0px;
        cursor: move;
        cursor: -webkit-grabbing;
        
        svg {
            width: 6px;
            height: 10px;
        }
    }

    &:not(:last-of-type) {
        border-bottom: 1px solid $color-porcelain;
    }

    &:nth-child(2n) {
        background-color: $color-catskill-white;
    }

    &:hover {
        @include media(hover) {
        background-color: $color-athens-gray;
        }
    }
    
    &__img {
        display: block;
        width: 50px;
        height: 50px;
        border: 1px solid $color-porcelain;
        margin-right: 10px;
        object-fit: contain;
        flex-shrink: 0;
    }

    &__label {
        color: $color-lochmara;
        margin-right: auto;
    }

    &__btn {
        margin-left: 5px;
    }

    &__popover {
    //   position: fixed;
    //   top: 200px;
    //   left: 200px;
      position: absolute;
      top:0;
      left: 0;
      font-size: 14.6px;
      line-height: 1.43;
      z-index: 50;

      h3 {
        margin-bottom: 5px;
      }

      strong {
        font-weight: 700;
      }

      .popover__close {
        position: absolute;
        top: 10px;
        right: 10px;
        font-size: 12px;
      }
    }

    &.-popovered {
        background-color: $color-athens-gray;

        .relation-list-item__btn.-info {
        border-color: #5c6ac4;
        outline: 0;
        box-shadow: 0 0 0 1px #5c6ac4;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/RelationListItem.vue